import React from 'react';

interface KeyResultProgressProps {
  currentValue: number;
  targetValue: number;
  unit: string;
  progressPercent: number;
}

const KeyResultProgress: React.FC<KeyResultProgressProps> = ({ currentValue, targetValue, unit, progressPercent }) => {
  return (
    <div className="key-result-progress">
      <div className="progress-values">
        <span>
          {currentValue} / {targetValue} {unit}
        </span>
        <strong>{Math.round(progressPercent)}%</strong>
      </div>
      <div className="progress-bar">
        <div className="progress-bar-fill" style={{ width: `${Math.min(progressPercent, 100)}%` }} />
      </div>
    </div>
  );
};

export default KeyResultProgress;
